module.exports = __webpack_public_path__ + "img/front-icon.b916eb45.svg";